import type { Building } from "building-types/building/buildingTypes";
import type { WallSettings } from "building-types/settings/wallSettings";
import { offsetPolyLine2 } from "geom/offset";
import { polyLine2Copy } from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";

export function getLevelSubRoofPerimeters(
  levelId: string,
  levels: Building["levels"],
  roofSystemLevels: Building["roofSystemLevels"],
  wallSettings: WallSettings,
): PolyLine2[] {
  if (!roofSystemLevels) {
    return [];
  }

  const level = levels[levelId];
  const roofLevel = level.levelBelow ? roofSystemLevels[level.levelBelow] : undefined;
  if (!roofLevel) {
    return [];
  }

  const exactSubRoofPerimeters: PolyLine2[] = [];
  // find the valid subroofs
  for (const subRoofId in roofLevel.roofPerimeters) {
    const { exactPerimeter } = roofLevel.roofPerimeters[subRoofId];
    exactSubRoofPerimeters.push(
      offsetPolyLine2(polyLine2Copy(exactPerimeter), -wallSettings.exteriorWallOffset), //offset negative to get back to centerLine
    );
  }
  return exactSubRoofPerimeters;
}

export function getLevelInsideCornerHalfEdges(
  planarGraphPerimeters: Building["planarGraphPerimeters"],
  levelId: string,
): { [halfEdge: number]: boolean } {
  const insideCornerHalfEdges = planarGraphPerimeters[levelId].insideCornerHalfEdges;
  const insideCornerHalfEdgesLookup: { [halfEdge: number]: boolean } = {};
  for (const he of insideCornerHalfEdges) {
    insideCornerHalfEdgesLookup[he] = true;
  }
  return insideCornerHalfEdgesLookup;
}
